module.exports = __webpack_public_path__ + "img/Volleyball.e5ca02b0.svg";